import { getDocumentAttributes } from "@common/features/document/helpers";
import { DocumentType } from "@common/types";

export const alreadyExistingDocumentTitleMessage = (contentType: DocumentType) => {
    const docAttributes = getDocumentAttributes(contentType, false);
    const contentOrDocumentTitle = docAttributes.allowHtmlContentUpload ? "content" : "document";
    return `A ${contentType} already exists with this ${contentOrDocumentTitle} title`
};
